import { ActionType } from "@xala/common-services";
import { Form, Input } from "@xala/common-ui";
import React from "react";
import { useTranslation } from "react-i18next";

interface IActionTypeURLProps {
  readonly actionType: ActionType | undefined;
}

function ActionTypeURL({ actionType }: Readonly<IActionTypeURLProps>) {
  const { t } = useTranslation();

  if (actionType !== ActionType.OpenUrl) {
    return null;
  }

  return (
    <Form.Item
      name="Url"
      label={t("NOTIFICATION_URL_CONTENT_FIELD")}
      key="Url"
      required
    >
      <Input placeholder={t("NOTIFICATION_URL_CONTENT_INPUT_FIELD")} />
    </Form.Item>
  );
}

export default ActionTypeURL;